import React from 'react';
import './index.css';
import { Box, Typography } from '@mui/material';

const Footer = ({
  content = `© ${new Date().getFullYear()} Copyright.Youngsoft.in`,
}) => {
  return (
    <Box className="footer-container">
      <Typography variant="body2">{content}</Typography>
    </Box>
  );
};

export default Footer;
